import React, { FC, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { useInjector } from 'utils/inject';

import { SoftwareInventorySidebar } from './Components/SoftwareInventorySidebar';
import { softwareInventorySaga } from './saga';
import { actions, reducer, sliceKey } from './slice';

export const SoftwareInventory: FC = () => {
  useInjector(sliceKey, reducer, softwareInventorySaga);
  const dispatch = useDispatch();
  const { accountId, environmentId } = useAccessBoundary();

  useEffect(() => {
    if (!accountId && !environmentId) return;

    dispatch(
      actions.getSoftwareInventory({
        q: { accountId, environmentId },
      }),
    );
  }, [accountId, dispatch, environmentId]);

  return (
    <Box h="full">
      <SoftwareInventorySidebar />
    </Box>
  );
};
